import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const FloatingDebrisAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 24; i++) {
    const a = (i / 24) * Math.PI * 2;
    const r = getRadiusAtAngle(a, e, e.maxRadius);
    const bx = Math.cos(a) * r;
    const by = Math.sin(a) * r;
    const driftX = Math.sin(progress * 8 + i) * 80;
    const driftY = -progress * 400;
    ctx.fillRect(e.pos.x + bx + driftX, e.pos.y + by + driftY, 8, 8);
  }
};

registerBlastAnimation('FLOATING_DEBRIS', FloatingDebrisAnimation);
